import './App.css';
import React from "react";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Header from "./Header";
import Footer from "./Footer";
import { Text } from "react-native";
import { withRouter } from "react-router-dom";
import { SpinnerComponent } from 'react-element-spinner';
import { REDEEM_ROUTE, RETRY_ROUTE, NOT_FOUND_ROUTE, OTHER_REDEEM_ROUTE } from './Constant';
import { AVAILABLE, REDEEMED, INVALID, OTHER_REDEEM } from './Constant';
import { VALIDATE_API_ROUTE, REDEEM_API_ROUTE } from './Constant';
import { TITLE_VALIDATE } from './Constant';

class Products extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            products: [],
            isActive: false,
            isHide: true
        };
    }

    handleClick(publisherCode, productCode) {
        this.setState({isActive: true});
        axios.post({REDEEM_API_ROUTE}.REDEEM_API_ROUTE + this.props.match.params.token + '/' + publisherCode + '/' + productCode).then(res => {
            this.setState({isActive: false});
            if (res.status === 200) {
                if (res.data.status === {INVALID}.INVALID) {
                    this.props.history.push({NOT_FOUND_ROUTE}.NOT_FOUND_ROUTE);
                } else if (res.data.status === {REDEEMED}.REDEEMED) {
                    this.props.history.push({REDEEM_ROUTE}.REDEEM_ROUTE + this.props.match.params.token);
                } else if (res.data.status === {OTHER_REDEEM}.OTHER_REDEEM) {
                    this.props.history.push({OTHER_REDEEM_ROUTE}.OTHER_REDEEM_ROUTE + this.props.match.params.token);
                } else {
                    this.props.history.push({RETRY_ROUTE}.RETRY_ROUTE + this.props.match.params.token);
                }
            } else {
                this.props.history.push({NOT_FOUND_ROUTE}.NOT_FOUND_ROUTE);
            }
        }).catch(error => {
            // In our case, redeem token receive any error just push to retry
            this.props.history.push({RETRY_ROUTE}.RETRY_ROUTE + this.props.match.params.token);
            // if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                // console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
            // } else if (error.request) {
                // The request was made but no response was received `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
                // console.log(error.request);
            // } else {
                // Something happened in setting up the request that triggered an Error
                // console.log('Error', error.message);
            // }
        })
    };

    componentDidMount(){
        document.title = {TITLE_VALIDATE}.TITLE_VALIDATE;
        axios.get({VALIDATE_API_ROUTE}.VALIDATE_API_ROUTE + this.props.match.params.token).then(res => {
            if (res.status === 200) {
                if (res.data.status === {AVAILABLE}.AVAILABLE) {
                    if (Object.keys(res.data.products).length === 1) {
                        // Directly redeem
                        this.handleClick(res.data.products[0].publisherCode, res.data.products[0].productCode);
                    } else {
                        // Show listing for user to choose which to redeem
                        this.setState({isHide: false});
                        this.setState({products: res.data.products})
                    }
                } else if (res.data.status === {INVALID}.INVALID) {
                    this.props.history.push({NOT_FOUND_ROUTE}.NOT_FOUND_ROUTE);
                } else if (res.data.status === {REDEEMED}.REDEEMED) {
                    this.props.history.push({REDEEM_ROUTE}.REDEEM_ROUTE + this.props.match.params.token);
                } else {
                    this.props.history.push({RETRY_ROUTE}.RETRY_ROUTE + this.props.match.params.token);
                }
            } else {
                this.props.history.push({NOT_FOUND_ROUTE}.NOT_FOUND_ROUTE);
            }
        }).catch(error => {
            // In our case, validate token receive any error just push to not found
            this.props.history.push({NOT_FOUND_ROUTE}.NOT_FOUND_ROUTE);
            // if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                // console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
            // } else if (error.request) {
                // The request was made but no response was received `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
                // console.log(error.request);
            // } else {
                // Something happened in setting up the request that triggered an Error
                // console.log('Error', error.message);
            // }
        })
    }

    render() {
        return (
            <div className="page-container">
                <SpinnerComponent loading={this.state.isActive} position="centered" message="Processing ..."/>
                <Header />
                <div className="text-center content-wrap">
                    <Container>
                        {
                            this.state.isHide ? null :
                                <Row>
                                    <Text style={{fontWeight: 'bold', color: '#605f61', fontSize: '18px', marginBottom: '20px'}}>Choose your game:</Text>
                                </Row>
                        }
                        {
                            this.state.products.length === 0
                                ? 'Loading Vouchers ...'
                                : this.state.products.map(product => (
                                    <Row key={product.productCode} className="align-items-center" style={{marginBottom: '10px', backgroundColor: '#f2f2f2'}}>
                                        <Col sm={6} className="text-center">
                                            <img className="vdsProductImg" src={product.productImage} alt={product.productCode} />
                                        </Col>
                                        <Col sm={6} className="text-center">
                                            <Button variant="primary" size="sm" id={product.productCode} onClick={() => this.handleClick(product.publisherCode, product.productCode)} style={{backgroundColor: '#439ccc'}}>REDEEM NOW</Button>
                                        </Col>
                                    </Row>
                                ))
                        }
                    </Container>
                </div>
                <Footer />
            </div>
        );
    }
}

export default withRouter(Products);